module.exports = __webpack_public_path__ + "static/media/33@2x.c9fb7622.png";